export const claimFilesTableStyle = () => ({
  display: "flex",
  height: "100%",
  overflow: "hidden",
});
